import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { parseApiDate } from '../../core/utils/date.util';

// Wraps Angular's DatePipe, but first normalizes the raw backend timestamp
// via parseApiDate() so naive/unzoned strings are interpreted correctly
// instead of being misread as already-local. Drop-in replacement for the
// built-in `date` pipe on any raw API timestamp field — same format
// strings, correct timezone handling. Mirrors unnanu-hire-app-angular's
// ApiDatePipe (src/app/shared/pipes/api-date.pipe.ts), which this app
// didn't have an equivalent of yet.
@Pipe({
	name: 'apiDate',
	standalone: true
})
export class ApiDatePipe implements PipeTransform {
	private _datePipe = new DatePipe('en-US');

	transform(value: any, format?: string): string {
		const date = parseApiDate(value);
		if (!date) return '';
		return this._datePipe.transform(date, format) || '';
	}
}
